import FacadeGlobal from '@/plugins/store/facades/facade-global';

export const fetchUserData = async ({ userId, store }) => {
  const facadeGlobal = new FacadeGlobal(store);

  await facadeGlobal.fetchUserData({ userId });
};
